import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

function normalizePathname(p) {
  if (p == null || p === '') {
    return '/';
  }
  const trimmed = p.replace(/\/$/, '');
  return trimmed === '' ? '/' : trimmed;
}

export default ({ title, path, icon, location }) => {
  const pathname = normalizePathname(location?.pathname);
  const href = `/${path}`.replace(/\/{2,}/g, '/');
  const targetPath = normalizePathname(href);
  const active = pathname === targetPath;

  const resolvedIcon = Array.isArray(icon) ? icon : ['far', icon];

  return (
    <Link to={href}>
      <li
        className={cn(
          'h-[60px] cursor-pointer pl-4 text-lg leading-[60px] transition-all duration-100 ease-out [&_svg]:mr-5',
          active
            ? 'bg-primary text-primary-foreground'
            : 'bg-transparent text-primary hover:bg-primary/10',
        )}
      >
        <FontAwesomeIcon icon={resolvedIcon} /> {title}
      </li>
    </Link>
  );
};
